module.exports = __webpack_public_path__ + "static/media/8.59aea437.jpg";